import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

export const _theme = createMuiTheme({
  typography: { useNextVariants: true },
  overrides: {
    MuiPaper: { root: { backgroundColor: '#f2f2f2' } },
    MuiInputBase: { root: { backgroundColor: '#fff' } },
  },
});

export default _theme;
